import apiClient from "./client";

export async function checkPseudoAvailability({ pseudo, uuid, signal } = {}) {
  const response = await apiClient.get("pseudo/check/", {
    signal,
    params: {
      pseudo,
      ...(uuid ? { uuid } : {}),
    },
  });
  return response.data;
}
